import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  TextInput,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
// import { navigationRef } from 'app/utils/RootNavigation';
import * as RootNavigation from "app/utils/RootNavigation.js";
import valueHelpers from "app/utils/valueHelpers";
import draggableHelpers from "app/utils/draggableHelpers";
import valueActions from "app/utils/valueActions";

import Hoverable from "app/components/Hoverable";
import DatePicker from "app/components/DatePicker";
import Value from "app/components/Value";
import ValueListItem from "app/components/ValueListItem";
import TimelineEvent from "app/components/TimelineEvent";
import Inspector from "app/components/Inspector";
import ValueInspector from "app/components/ValueInspector";
import Draggable from "app/components/Draggable";
import Note from "app/components/Note";
import RecursiveTimelineNodes from "app/components/RecursiveTimelineNodes";
import {
  Ionicons,
  Entypo,
  Feather,
  Octicons,
  MaterialIcons,
  MaterialCommunityIcons,
  FontAwesome,
} from "@expo/vector-icons";

export default class TimelineNodes extends React.Component {
  static propTypes = {
    // value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    value: PropTypes.object.isRequired,
    onPress: PropTypes.func,
    // deleteDoneAt: PropTypes.func.isRequired,
    // onProgress: PropTypes.func.isRequired,
    // onUpdate: PropTypes.func,
    wrapperStyle: PropTypes.object,
    list: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      newProgressAt: null,
      newnote: null,
      note: null,
      selectedItems: [],
      loggingProgress: false,
      draggingValue: null,
      hovering: false,
      recursiveTimelineValue: null,
    };
  }

  render() {
    let { value, onProgress, wrapperStyle, list } = this.props;
    let {
      newProgressAt,
      newNote,
      selectedItems,
      loggingProgress,
      draggingValue,
      hovering,
    } = this.state;

    let progressions = valueHelpers.getProgressions({ value });

    return (
      <View
        style={[
          list ? styles.listWrapper : styles.wrapper,
          wrapperStyle,
          //hovering ? null : {paddingHorizontal: 50},
        ]}
      >
        <ScrollView
          horizontal={!list}
          style={
            ENV.WEB
              ? {
                  maxWidth: "100%",
                  // minWidth: '100%',
                  overflowX: list ? "visible" : "auto",
                  overflowY: "visible",
                }
              : {
                  maxWidth: "100%",
                }
          }
          contentContainerStyle={[!list && styles.row]}
        >
          {this.renderNotes(value.notes)}

          <View style={list ? [] : [styles.rowBorderWrapper]}>
            {!list && <View style={styles.rowBorder} />}

            {this.renderMileMarker(value.created_at, "Created")}

            {this.renderProgressions(progressions, value.note_objects)}

            {!!progressions.length &&
              !valueHelpers.getCompletedAt(value) &&
              this.renderMileMarker(
                valueHelpers.getPropagatedUpdatedAt({
                  value,
                  includeCreatedAt: true,
                }),
                "Updated",
              )}

            {this.renderIncompleteChildren(value, progressions)}

            {!!valueHelpers.getCompletedAt(value) &&
              this.renderMileMarker(
                valueHelpers.getCompletedAt(value),
                "Completed",
              )}
          </View>

          {this.renderAddButton(value)}

          {this.renderIncompleteChildren(value, progressions, true)}
        </ScrollView>

        {/*this.renderIncompleteChildren(value)*/}
      </View>
    );
  }

  renderProgressions = (progressions, notes = []) => {
    let items = [...progressions, ...notes];
    console.log(items);
    return items.map((item, i) => {
      return this.renderNode(item, i);
    });
  };

  renderIncompleteChildren = (
    value = {},
    progressions = [],
    overflow = false,
  ) => {
    let children = valueHelpers
      .getChildren(value)
      .filter((c) => !c.completed_at && !c.archived_at);

    // hide project children, unless also a project yourself
    if (!valueHelpers.isInfinite(value, false)) {
      children = children.filter((c) => !valueHelpers.isInfinite(c, false));
    }

    children = children.reverse();
    children = textHelpers.oldestFirst(children, "created_at");
    let cycle = !!value?.cycle || value?.cycle === 0 ? value.cycle : ENV.CYCLE;
    if (cycle == 0) {
      children = overflow ? [] : children;
    } else {
      if (!!progressions?.length) {
        cycle -= progressions.length;
      }
      if (overflow) {
        children = children.slice(cycle);
      } else {
        children = children.slice(0, cycle);
      }
    }

    return children?.map((child, i) => {
      return this.renderNode(
        {
          ...child,
          // backgroundOpacity: ENV.DARK ? 0.0000001 : 0.4,
          // backgroundColor: ENV.LIGHT ? colorHelpers.modifyHex(colors.empty, colors.darkenBy) : undefined,
          // timestamp: child.created_at,
          timestamp: valueHelpers.getPropagatedUpdatedAt({ value: child }),
        },
        i + (value?.timeline?.length || 0),
      );
    });
  };

  renderAddButton = (value) => {
    let { loggingProgress } = this.state;
    let { list, noIcon, condensed } = this.props;
    if (noIcon) condensed = true;
    if (!loggingProgress) {
      if (list) {
        return (
          <ValueListItem
            onPress={() => this.setState({ loggingProgress: true })}
            value={{ text: "", icon: valueHelpers.getIcon(value) }}
            backgroundColor={colors.trim}
            // backgroundColor={'transparent'}
            style={{
              // marginLeft: condensed ? 0 : sizes.extraGiant,
              borderWidth: 2,
              borderColor: colors.trim,
              marginBottom: sizes.small,
            }}
            //date={this.props.date}
            //emptyColor={colors.trim}
            // scale={0.5}
            scale={this.props.scale || 0.5}
            iconScale={this.props.iconScale}
            hideButtons
            renderButton={(style, color) => (
              <Ionicons
                name={"md-add-circle-outline"}
                style={style}
                color={colors.trim}
              />
            )}
            minWidth={300}
          />
        );
      } else {
        return (
          <Hoverable
            onHoverIn={() => {
              // console.log('hover in')
              this.setState({ hovering: true });
            }}
            onHoverOut={() => {
              // console.log('hover out')
              this.setState({ hovering: false });
            }}
          >
            {(isHovered) => {
              let size = 60;
              if (isHovered) size = 100;
              // return <View />
              return (
                <View>
                  <Value
                    onPress={() => this.setState({ loggingProgress: true })}
                    // value={{text: '+', id: 'ftue'}}
                    value={{ text: "+" }}
                    size={size}
                    selected
                    date={this.props.date}
                    emptyColor={colors.fill}
                  />
                </View>
              );
            }}
          </Hoverable>
        );
      }
    } else {
      return (
        <ValueInspector
          fullBleed={list}
          style={list && { marginLeft: sizes.extraGiant }}
          composer
          parent={value}
          value={value}
          // onProgress={this.props.onProgress}
          // onCreateChild={this.props.onCreateChild}
          onClose={() => this.setState({ loggingProgress: false })}
          date={this.props.date}
        />
      );
    }
  };

  renderNode = (item, i) => {
    let { value, values, list } = this.props;
    let { selectedItems, draggingValue, recursiveTimelineValue } = this.state;

    let type = item.type;
    let selected = selectedItems.includes(item.timestamp);
    // let itemIsValue = !!item.value?.id && item.value?.id != value.id
    let itemIsValue =
      !!item?.id && typeof item.id !== "string" && !item.is_note;
    let val = item;
    // console.log(val)
    if (itemIsValue) {
      //   let fullVal = values?.find(v => v.id == item.value.id) || {}
      //   val = {
      //     ...item.value,
      //     ...fullVal,
      //   }
    } else {
      // val = {
      //   ...item,
      //   color: valueHelpers.getColor(value),
      //     ...value,
      //     progress_at: [],
      //     revision_ids: [],
      // text: item.note?.substr(2) || '✓',
      //     completed_at: item.timestamp,
      // }
    }
    if (type == "child_completion") {
      itemIsValue = true;
      // console.log(item)
      if (!!item.value) {
        val = item.value;
      } else {
        val = { color: value.color, icon: value.icon, id: value.id, ...item };
      }
    }
    // console.log(itemIsValue, val, item)
    // if(!!val){
    //   if(type == 'archival'){
    //     val.id = 'ftue'
    //     val.text = <Feather name={'archive'} color={colors.lightForeground} size={sizes.large} />
    //   }
    //   else if (type == 'creation'){
    //     return null
    //     val.id = 'ftue'
    //     val.text = 'created'
    //   }
    //   else if (type == 'extension'){
    //     return null
    //     val.id = 'ftue'
    //     val.text = 'extended'
    //   }
    //   else if (type == 'completion'){
    //     val.id = 'ftue'
    //     val.text = <MaterialIcons name={'check-circle'} color={colors.lightForeground} size={sizes.large} />
    //   }
    // }

    let isDragging = false;
    if (!!draggingValue && draggingValue.id == val.id) {
      isDragging = true;
    }

    let isRecurring = false;
    if (itemIsValue && val.id == recursiveTimelineValue?.id) {
      isRecurring = true;
    }

    if (list) return this.renderListItem(val, i, itemIsValue, selected);

    return (
      <View
        key={i}
        style={[
          { zIndex: isRecurring ? 2 : 1 },
          //{borderWidth: 3, borderColor: 'purple'},
          //{width: 100},
          //{flex: 1},
        ]}
      >
        <Hoverable
          // style={isDragging || selected ? {zIndex: 3, borderWidth: 4, borderColor: 'red'} : {zIndex: -1}}
          onHoverIn={() => {
            // console.log('hover in')
            this.setState({ hovering: true });
          }}
          onHoverOut={() => {
            // console.log('hover out')
            this.setState({ hovering: false });
          }}
        >
          {(isHovered) => {
            let size = this.props.size || 60;
            // if(isHovered || selected || isRecurring) size *= 2
            // let isSelected = (isHovered || selected || isRecurring)
            let scaleItem = (isHovered || isRecurring) && !selected;
            if (scaleItem) size *= this.props.hoverScaleFactor || 1.5;

            return (
              <View
                style={[
                  { flex: -1, alignItems: "center" },
                  isDragging || selected ? { zIndex: 3 } : { zIndex: -1 },
                  scaleItem && {
                    zIndex: 3,
                    //   transform: [
                    //     {scale: 1.5},
                    //     {translateY: `25%`},
                    //   ],
                  },
                ]}
              >
                {selected ? (
                  <ValueInspector
                    fullBleed={list}
                    value={val}
                    // item={item}
                    parent={value}
                    onClose={() => this.toggleSelected(item)}
                    // onUpdate={this.props.onUpdate}
                    // deleteDoneAt={this.props.deleteDoneAt}
                    // date={this.props.date}
                  />
                ) : itemIsValue ? (
                  <Draggable
                    onDragMove={(coords) =>
                      this.props.onDragMove && this.props.onDragMove(coords)
                    }
                    onDragEnd={(coords) => {
                      this.setState({ draggingValue: null });
                      this.props.onDragEnd && this.props.onDragEnd(coords);
                    }}
                    onDragStart={() => {
                      this.setState({ draggingValue: val });
                      this.props.onDragStart && this.props.onDragStart(val);
                    }}
                    freezeOnRelease={this.props.freezeOnRelease}
                    shelfThreshold={this.props.shelfThreshold}
                    onShelf={() => this.props.onShelf(val)}
                  >
                    {(isDragging) => {
                      if (isDragging) size = 60;
                      let textIcon =
                        val.id == this.props.draggingValue?.id &&
                        draggableHelpers.determineTextIcon(
                          val,
                          this.props.overlappedValue,
                        );
                      let scale = null;
                      // if(!!textIcon) size *= 0.66
                      // else if(this.props.overlappedValue?.id == value.id) size *= 1.1
                      if (!!textIcon) scale = 0.66;
                      else if (this.props.overlappedValue?.id == val.id)
                        scale = 1.1;
                      return (
                        <Value
                          // node value
                          textIcon={textIcon}
                          size={size}
                          scale={scale}
                          selected={this.props.overlappedValue?.id == val.id}
                          value={val}
                          // ringColor={valueHelpers.getColor(item.value)}
                          onPress={() =>
                            isDragging
                              ? null
                              : this.handlePress(item, itemIsValue)
                          }
                          // onLongPress={() => isDragging ? null : this.handleLongPress(item, itemIsValue)}
                          // onPress={() => null}
                          wrapperStyle={
                            isRecurring && { paddingBottom: sizes.giant }
                          }
                          ref={(ref) => {
                            this[`val_${val.id}`] = ref;
                            this.props.setValueRef &&
                              this.props.setValueRef(ref, `val_node_${val.id}`);
                          }}
                          date={this.props.date}
                        />
                      );
                    }}
                  </Draggable>
                ) : (
                  <Value
                    size={size}
                    ringColor={valueHelpers.getColor(value)}
                    noteValue
                    value={val}
                    onPress={() => this.handlePress(item, itemIsValue)}
                    // onLongPress={() => isDragging ? null : this.handleLongPress(item, itemIsValue)}
                    date={this.props.date}
                  />
                )}
                {/*selected && (
                  <Inspector
                    item={item}
                    parent={value}
                    onClose={() => this.toggleSelected(item)}
                    onUpdate={this.props.onUpdate}
                    deleteDoneAt={this.props.deleteDoneAt}
                  />
                )*/}
              </View>
            );
          }}
        </Hoverable>
        {isRecurring && (
          <View
            style={{
              width: "100%",
              // top: '125%'
              //borderWidth: 5,
              // height: 100,
              alignItems: "center",
              zIndex: 4,
            }}
          >
            <View
              style={
                {
                  // position: 'absolute',
                }
              }
            >
              <RecursiveTimelineNodes value={val} />
            </View>
          </View>
        )}
      </View>
    );
  };

  renderListItem = (value, i, itemIsValue, selected) => {
    if (selected) {
      return (
        <View style={styles.nestedItem} key={i}>
          <View style={styles.nestedGutter} />
          <ValueInspector
            fullBleed
            value={value}
            parent={this.props.value}
            onClose={() => this.toggleSelected(value)}
            // onUpdate={this.props.onUpdate}
            // deleteDoneAt={this.props.deleteDoneAt}
            // date={this.props.date}
          />
        </View>
      );
    }
    return (
      <View style={styles.nestedItem} key={i}>
        {
          <View style={styles.nestedGutter}>
            {/*<Text style={{}} numberOfLines={1}>
            {textHelpers.formatDate(value.timestamp, true).split(' ')[0]}
          </Text>
          <Text style={{}} numberOfLines={1}>
            {textHelpers.formatTime(value.timestamp, true)}
          </Text>
          <Text style={{}} numberOfLines={1}>
            {textHelpers.formatDate(value.timestamp, true).split(' ')[1]}
          </Text>*/}
          </View>
        }
        <ValueListItem
          value={value}
          hideButtons
          style={{ flex: 1, marginBottom: sizes.small }}
          onPress={
            itemIsValue ? undefined : () => this.handlePress(value, itemIsValue)
          }
          noIcon={this.props.noIcon}
          scale={this.props.scale || 0.5}
          iconScale={this.props.iconScale}
          condensed={this.props.condensed}
          minWidth={this.props.minWidth}
        />
      </View>
    );
  };

  renderMileMarker = (timestamp, title) => {
    let { list, noIcon, condensed } = this.props;
    if (noIcon) condensed = true;
    if (list) {
      return (
        <View style={[styles.mmWrapperList, condensed && { paddingLeft: 0 }]}>
          {/*<View style={styles.mmList} />*/}
          <Text style={[]}>
            {title}
            {condensed ? ": " : ""}
          </Text>
          <Text style={[]}>
            {textHelpers.formatDate(timestamp, condensed, !condensed)} –{" "}
            {textHelpers.formatTime(timestamp, condensed)}
          </Text>
        </View>
      );
    } else {
      return (
        <Hoverable>
          {(isHovered) => (
            <View style={styles.mmWrapper}>
              <View style={styles.mm} />
              <Text style={[styles.mmText, styles.mmText1]}>{title}</Text>
              {isHovered && (
                <Text style={[styles.mmText, styles.mmText2]}>
                  {textHelpers.formatDate(timestamp, true)} -{" "}
                  {textHelpers.formatTime(timestamp)}
                </Text>
              )}
              {/*isHovered && (
                <Text style={[styles.mmText, styles.mmText2]}>{textHelpers.formatTime(timestamp)}</Text>
              )*/}
              {/*{isHovered && (
                <Text style={[styles.mmText, styles.mmText3]}>{textHelpers.formatDate(timestamp)}</Text>
              )}*/}
            </View>
          )}
        </Hoverable>
      );
    }
  };

  renderNotes = (notes = []) => {
    return notes.map((note, i) => {
      // let text = note.slice(note.indexOf(":") + 1);
      let text = typeof note == "string" ? note : note?.text;
      // text = note;
      return <Note key={i}>{text}</Note>;
    });
  };

  handlePress = (item, itemIsValue) => {
    // console.log(item, itemIsValue)
    if (itemIsValue) {
      // RootNavigation.push('Value', {id: item.value.id, value: item.value})
      let val = !item.value?.id ? item : item.value;
      // console.log('toggle timeline')
      this.toggleTimeline(val);
    } else {
      // console.log('toggle selected')
      this.toggleSelected(item);
    }
  };

  handleLongPress = (item, itemIsValue) => {
    if (itemIsValue) {
      let val = !item.value?.id ? item : item.value;
      RootNavigation.push("Value", { id: val.id, value: val });
    }
  };

  toggleTimeline = (value) => {
    let { recursiveTimelineValue } = this.state;
    if (recursiveTimelineValue?.id == value?.id) {
      this.setState({ recursiveTimelineValue: null });
    } else {
      console.log(value);
      this.setState({ recursiveTimelineValue: value });
    }
  };

  toggleSelected = (item) => {
    let { selectedItems } = this.state;
    if (selectedItems.includes(item.timestamp)) {
      // selectedItems = selectedItems.filter(x => x != item.timestamp)
      selectedItems.splice(selectedItems.indexOf(item.timestamp), 1);
    } else {
      // selectedItems = [...selectedItems, item.timestamp]
      selectedItems.push(item.timestamp);
    }
    this.setState({ selectedItems });
  };
}

const styles = StyleSheet.create({
  wrapper: {
    zIndex: -1,
    flex: -1,
    // alignSelf: 'stretch',
    alignSelf: "center",
    alignItems: "center",
    // justifyContent: 'space-around',
    // flexWrap: 'nowrap',
    // minHeight: 200,
    width: "100%",
  },
  listWrapper: {
    width: "100%",
    // borderWidth: 1, borderColor: 'red',
  },
  row: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
    justifyContent: "flex-start",
    // alignItems: 'center',
    paddingHorizontal: 50,
    paddingTop: 50,
    paddingBottom: 50,
  },
  rowBorderWrapper: {
    flexDirection: "row",
    // flex: 1,
  },
  rowBorder: {
    ...StyleSheet.absoluteFillObject,
    bottom: "auto",
    height: 100,
    borderWidth: 2,
    borderColor: colors.trim,
    borderRadius: 50,
  },
  mmWrapper: {
    alignItems: "center",
    height: 100,
  },
  mm: {
    width: 1,
    // flex: 1,
    top: "50%",
    height: "50%",
    marginHorizontal: sizes.small,
    backgroundColor: colors.trim,
  },
  mmWrapperList: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingLeft: sizes.extraGiant,
  },
  mmList: {},
  mmText: {
    color: colors.trim,
    position: "absolute",
    width: 200,
    textAlign: "center",
  },
  mmText1: {
    bottom: -sizes.default * 1.5,
  },
  mmText2: {
    bottom: -sizes.default * 1.5 * 2,
  },
  mmText3: {
    bottom: -sizes.default * 1.5 * 3,
  },
  nestedItem: {
    flexDirection: "row",
    alignSelf: "stretch",
    // borderWidth: 2, borderColor: 'red',
    // width: '100%',
  },
  nestedGutter: {
    // width: sizes.extraGiant,
    justifyContent: "flex-start",
  },
  note: {
    maxWidth: 250,
    borderRadius: 5,
    backgroundColor: colors.fill,
    padding: 10,
  },
});
